module.exports = __webpack_public_path__ + "img/mongoDb.fc44a3bd.png";